var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml"},[(!_vm.hidden)?_c('b-button',{attrs:{"loading":_vm.loading,"icon-right":"plus","type":"is-primary","outlined":"","size":"is-small"},on:{"click":_vm.onClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }